import { useEffect } from 'react';

import useIsFirstRender from './useIsFirstRender';
import { useRef } from 'react';

// Skip invoking on initial render
// Run only on next updates
const useNextEffect = (callback = () => {}, deps = null) => {
	const cleanUp = useRef(() => {});
	const isFirstRender = useIsFirstRender();

	useEffect(() => {
		if (!isFirstRender) {
			cleanUp.current = callback();
		}
		return cleanUp.current;
		//eslint-disable-next-line
	}, deps);

	return null;
};

export default useNextEffect;
